import React, { Component } from 'react';
import ReactTable from "react-table";
import { withRouter } from 'react-router-dom';

import couterpart from 'counterpart';
import DatePicker from 'react-datepicker';
// import ReactTablePagination from './PaginationComponent';
import {ToastsContainer, ToastsStore} from 'react-toasts';

import { FaFilter, FaEdit } from 'react-icons/fa';

import "react-table/react-table.css";
import "../css/style.css";

import MenuComponent2 from './MenuComponent2';
import WorkOrdersListByOrderId from './WorkOrdersListByOrderId';
import WorkOrderUtil from '../utilities/WorkOrderUtil';
import OrderPrint from './OrderPrint';
import queryString from 'query-string'

import { SELECTED_ORDER_ID,
        SELECTED_ORDER_IDX,
        SELECTED_ORDER_PAGE,
        SELECTED_ORDER_NO} from '../constants';
import OrderDataService from '../services/OrderDataService';
import MasterDataService from '../services/MasterDataService';
import AuthenticationService from '../services/AuthenticationService';
import { ICON_COLOR} from '../icon';

class OrderList extends Component {
  constructor () {
    super();
    const numOfMonths = 24;
    var fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000*3);//1 month
    fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    var toDate = new Date();
    toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);

    this.state = {
      allStatus: [],
      selectedPage: this.getSelectedOrderPage(),
      fromDate: fromDate,
      toDate: toDate,
      orders: [],
      workOrders: [],
      countries: [],
      columns : [
        {
          id: "idx",
          accessor: "",
          width: 40,
          Cell: row =>(
            <div style={{ padding: "10px"}}>{row.index + 1}</div>
          )
        },          
        {
          id: "checkbox",
          accessor: "",
          Cell: ({ original }) => {
            return (
              <div style={{ textAlign: "center" }}>
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selected[original.id] === true}
                onChange={() => this.toggleRow(original.id)}
              /></div>
            );
          },
          Header: x => {
            return (
              <input
                type="checkbox"
                className="checkbox"
                checked={this.state.selectAll === 1}
                ref={input => {
                  if (input) {
                    input.indeterminate = this.state.selectAll === 2;
                  }
                }}
                onChange={() => this.toggleSelectAll()}
              />
            );
          },
          sortable: false,
          width: 45
        },        
        {
          Header: couterpart.translate('order_no'),
          accessor: 'orderNo',
          filterable: false
        },        
        {
          Header: couterpart.translate('wo_count'),
          accessor: 'woCount',
          filterable: false
        },{
          Header: couterpart.translate('order_status'),
          accessor: 'status',
          filterable: false,          
          Cell: props => this.getStatusDescription(props.value)
        },{
          Header: couterpart.translate('order_date'),
          accessor: 'orderDate',
          filterable: false,
          Cell: props => WorkOrderUtil.formatShortDisplayDateMMddyyyy(props.value)
        },{
          Header: couterpart.translate('customer_name'),
          accessor: 'customerName',
          filterable: false
        },{
          Header: couterpart.translate('customer_country'),
          accessor: 'country',
          filterable: true,
          filterMethod: (filter, row) => {
            if (filter.value === "all") {
              return true;
            }
            if (filter.value === "US") {
              return row[filter.id] === 'US';
            }
            if (filter.value === "AU") {
              return row[filter.id] === 'AU';
            }            
            return true;
          },          
          Filter: ({ filter, onChange }) =>
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "all"}
            >
              <option value="all">All</option>
              <option value="US">US</option>
              <option value="AU">AU</option>
            </select>                     
        },{
          Header: couterpart.translate('ship_to'),
          accessor: 'shipTo',
          filterable: false                         
        },{
          Header: couterpart.translate('uploaded_at'),
          accessor: 'uploadedAt',
          filterable: false,
          Cell: props => props.value
        }
      ],
      selected: this.getSelectedOrderIdx(),
      orderId: this.getSelectedOrderId(),
      selectedOrderNo: this.getSelectedOrderNo()
    };
  }

  onFilteredChangeCustom = (value, accessor) => {
    let filtered = this.state.orders;
    let insertNewFilter = 1;

    if (filtered.length > 0) {
      filtered.forEach((filter, i) => {
        if ("country" === accessor) {
          if (value === "" || !value.length) filtered.splice(i, 1);
          else filter["value"] = value;
          insertNewFilter = 0;
        }
      });
    }

    if (insertNewFilter) {
      filtered.push({ id: accessor, value: value });
    }

    this.setState({ filtered: filtered });
  };

  loadCountries(){
    MasterDataService.retrieveCountryMappings().then(data => {
      if (data !== undefined && data !== null && data instanceof Array){
        let countries = [];
        for(let i=0; i< data.length; i++){
          let code = data[i].code;
          countries.push({
            id: code,
            name: code
          });
        }
        this.setState({ countries:  countries})
      } 
    });
  } 

  componentDidMount () {
    this.loadCountries();
    MasterDataService.retrieveAllStatus().then(data => {
      this.setState({ allStatus:  data}) 
    });

    let fromDate = WorkOrderUtil.getItem("orders.fromDate");
    let toDate = WorkOrderUtil.getItem("orders.toDate");

    const numOfMonths = 12;
    if (fromDate === null || fromDate === undefined) {
      fromDate = new Date(new Date().getTime() - numOfMonths*30*24*60*60*1000);//numOfMonths month
      fromDate = WorkOrderUtil.convertToyyyyMMddhhmmString(fromDate);
    }

    if (toDate === null || toDate === undefined) {
      toDate = new Date();
      toDate = WorkOrderUtil.convertToyyyyMMddhhmmString(toDate);
    }

    let tmp = WorkOrderUtil.getItem('orders.selectedPage');
    let iSelectPage = 0;
    if (tmp !== undefined) {
      iSelectPage = parseInt(tmp);
    }
    let selectedRow = WorkOrderUtil.getItem('orders.selectedRow') ? parseInt(WorkOrderUtil.getItem('orders.selectedRow')) : 0
    let selectedOrderId = WorkOrderUtil.getItem('orders.orderId') ? parseInt(WorkOrderUtil.getItem('orders.orderId')) : 0
    let selectedOrderNo = WorkOrderUtil.getItem('orders.selectedOrderNo') ? WorkOrderUtil.getItem('orders.selectedOrderNo') : ''
    console.log('iSelectPage', iSelectPage)
    this.setState({ 
      fromDate:  fromDate, 
      toDate: toDate, 
      status: WorkOrderUtil.getItem("orders.status"), 
      country: WorkOrderUtil.getItem("orders.country"),
      customer: WorkOrderUtil.getItem("orders.customer"),
      orderNo: WorkOrderUtil.getItem("orders.orderNo"),
      woStatus: WorkOrderUtil.getItem("orders.woStatus"),
      selectedOrderNo: selectedOrderNo, 
      selectedPage: iSelectPage, 
      selectedRow: selectedRow,
      orderId: selectedOrderId
    }, () => {
      const query = queryString.parse(this.props.location.search);
      if (query.caller !== '0'){ //Clicked on NAV
          this.filterOrdersBy();
      }        
    });       
     
  }

  toggleRow(id) {
		const newSelected = Object.assign({}, this.state.selected);
		newSelected[id] = !this.state.selected[id];
		this.setState({
			selected: newSelected,
			selectAll: 2
		}, () =>{
      sessionStorage.setItem(`${SELECTED_ORDER_IDX}`, this.state.selected);
    });
	}

  onFilter() {
    this.clearSearchInfo();
    this.filterOrdersBy();
  }

	toggleSelectAll() {
		let newSelected = {};

		if (this.state.selectAll === 0) {
			this.state.orders.forEach(x => {
				newSelected[x.id] = true;
			});
		}

		this.setState({
			selected: newSelected,
			selectAll: this.state.selectAll === 0 ? 1 : 0
		});
	}
  
  clearSearchInfo() {
    sessionStorage.removeItem("orders.fromDate")
    sessionStorage.removeItem("orders.toDate")
    sessionStorage.removeItem("orders.status")
    sessionStorage.removeItem("orders.country")
    sessionStorage.removeItem("orders.customer")
    sessionStorage.removeItem("orders.orderNo")
    sessionStorage.removeItem("orders.woStatus")

  }
  saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus){
    sessionStorage.setItem("orders.fromDate", fromDate);
    sessionStorage.setItem("orders.toDate", toDate);  
    WorkOrderUtil.saveItem("orders.status", status);
    WorkOrderUtil.saveItem("orders.country", country);
    WorkOrderUtil.saveItem("orders.customer", customer);
    WorkOrderUtil.saveItem("orders.orderNo", orderNo);
    WorkOrderUtil.saveItem("orders.woStatus", woStatus);
  }  

  filterOrdersBy(){   
    var fromDate = this.state.fromDate;
    var toDate = this.state.toDate;
    var status = this.state.status;
    var woStatus = this.state.woStatus;
    var country = this.state.country;
    var customer = this.state.customer;
    var orderNo = this.state.orderNo;

    console.log("orders.fromDate, orders.toDate, orders.status, orders.woStatus, orders.country, orders.customer, orders.orderNo", 
      fromDate, toDate, status, woStatus, country, customer, orderNo)
    OrderDataService.retrieveOrdersBy(fromDate, toDate, status, country, customer, orderNo, woStatus)
      .then(data => {
      if(data.message === undefined){
        this.setState({ orders:  data });
        this.saveSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus);

      }else{
        this.setState({ orders:  [], orderId:0, selectedOrderNo:''});
        ToastsStore.error(data.message);
      }   
    });
  }

  changeOrdersStatus(){
    if (this.state.selected.length < 1){
      ToastsStore.error("Xin chọn tình trạng");
      return;
    }

    if (this.state.orderNote === undefined || this.state.orderNote === null || this.state.orderNote.trim().length < 1){
      ToastsStore.error("Xin chọn ghi chú");
      return;
    }

    if (this.state.newStatus === null || this.state.newStatus === undefined || this.state.newStatus.length < 1){
      return;
    }
    var ids = [];

    for(var prop in this.state.selected) {
      if (this.state.selected[prop] === true){
        ids.push(prop);
      }  
    }

    OrderDataService.updateStatus(this.state.newStatus, this.state.orderNote, ids).then(data => {
      if(data.message === undefined){
        var fromDate = this.state.fromDate;
        var toDate = this.state.toDate;
        var status = this.state.status;
        var country = this.state.country;
        var customer = "";
        var selectedOrderNo = "";

        OrderDataService.retrieveOrdersBy(fromDate, toDate, status, country, customer, selectedOrderNo).then(data => {
          if(data.message === undefined){
            this.setState({ orders:  data, orderId:0, selectedOrderNo:'',selectedPage:0, selected: {}, selectAll: 0});
          }else{
            ToastsStore.error(data.message);
          }   
        });
      }else{
        ToastsStore.error(data.message);
      }   
    });
  }

  handleEdit(e){
      ToastsStore.error(e.name);
  }

  handleDelete(e){
      ToastsStore.error(e.age);
  }

  getStatusDescription(status){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return status;
    }    
    let istatus = parseInt(status);
    let statusInfo = this.state.allStatus.find(x =>{
      return x.status === istatus;
    });
    if (statusInfo !== undefined){
      return statusInfo.statusDescVn;
    }   
    return status;    
  }

  getSelectedOrderPage(){
    var selected = sessionStorage.getItem(`${SELECTED_ORDER_PAGE}`);
    if((selected === undefined) || (selected === null)){
      selected = "0";
    }
    return parseInt(selected, 10);
  }

  getSelectedOrderIdx(){
    var selected = sessionStorage.getItem(`${SELECTED_ORDER_IDX}`);
    if((selected === undefined) || (selected === null)){
      selected = "-1";
    }
    return parseInt(selected, 10);
  }

  getSelectedOrderId(){
    var selected = sessionStorage.getItem(`${SELECTED_ORDER_ID}`);
    if((selected === undefined) || (selected === null)){
      selected = "-1";
    }
    return selected;
  }

  getSelectedOrderNo(){
    var selected = sessionStorage.getItem(`${SELECTED_ORDER_NO}`);
    if((selected === undefined) || (selected === null)){
      selected = "";
    }
    return selected;
  }

  handleFromDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      fromDate: sDate                   
    }));
  }

  handleToDateChange(date){
    var sDate = WorkOrderUtil.convertToyyyyMMddhhmmString(date);
    this.setState(prevState => ({                 
      toDate: sDate                   
    }));
  }

  handleStatusChange(e){
    var value = e.target[e.target.selectedIndex].value;
    sessionStorage.setItem("orders.status", value)
    this.setState(prevState => ({                 
      status: value                   
    }));
  }

  handleWoStatusChange(e){
    var value = e.target[e.target.selectedIndex].value;
    sessionStorage.setItem("orders.woStatus", value)
    this.setState(prevState => ({                 
      woStatus: value                   
    }));
  }

  handleSetStatusChange(e){
    var value = e.target[e.target.selectedIndex].value;
    this.setState(prevState => ({                 
      newStatus: value                   
    }));
  }

  handleOrderNoteChange(e){
    var newValue = e.target.value;
    this.setState(prevState => ({                 
      orderNote: newValue                   
    }));
  }

  handleCountryChange(e){
    var value = e.target[e.target.selectedIndex].value;
    sessionStorage.setItem("orders.country", value)
    this.setState(prevState => ({                 
      country: value                   
    }));
  }

  handleCustomerChange(e){
    var value = e.target.value;
    sessionStorage.setItem("orders.customer", value)
    this.setState(prevState => ({                 
      customer: value                   
    }));
  }

  handleOrderNoChange(e){
    var value = e.target.value;
    sessionStorage.setItem("orders.orderNo", value)
    this.setState(prevState => ({                 
      orderNo: value                   
    }));
  }

  renderStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
    return(
      <select onChange={this.handleStatusChange.bind(this)} 
        value={ this.state.status }>
        <option value="all">{couterpart.translate('workorder_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 1;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }

  renderWoStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }
        
    return(
      <select onChange={this.handleWoStatusChange.bind(this)} 
        value={this.state.woStatus}>
        <option value="all">{couterpart.translate('order_status_all')}</option>
        { this.state.allStatus.filter(y =>{
          return y.type === 2;
        }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
      </select>
    );
  }  

  renderChangeStatusList(){
    if (this.state.allStatus === undefined || this.state.allStatus === null){
        return (<></>);
    }  
    if (AuthenticationService.isAdmin()){
      return(
        <select onChange={this.handleSetStatusChange.bind(this)} style={{ margin:"5px", padding:"2px"}}>
          { this.state.allStatus.filter(y =>{
            return y.type === 1 && y.status !== 1;
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      );      
    } else {
      return(
        <select onChange={this.handleSetStatusChange.bind(this)}  style={{ margin:"5px", padding:"2px"}}>
          { this.state.allStatus.filter(y =>{
            return y.type === 1;
          }).map(x => <option value={x.status} key={x.status}>{x.statusDescVn}</option>)}
        </select>
      );
    }
  }

  renderCountryList(){
    if (this.state.countries === undefined || this.state.countries === null){
        return (<></>);
    }
    return(
      <select onChange={this.handleCountryChange.bind(this)}
        value={this.state.country}>
        <option value="all">{couterpart.translate('order_country_all')}</option>
        { this.state.countries.map(x => <option value={x.name} key={x.name}>{x.name}</option>)}
      </select>
    );
  }

  render() {
    if (!AuthenticationService.isAdmin() && !AuthenticationService.isService()){
      return (<div>Unauthorized access.</div>);
    }

    return (
          <div>
              <MenuComponent2/>
              <ToastsContainer store={ToastsStore} position="bottom_center" />
              <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px'}}>
                <div className="col-12">
                  <div className="row" style={{ margin: '2px'}}>
                  <div className="col-4 border-top border-left border-right border-bottom border-light-gray" style={{ padding: '5px'}}>
                    <div className="row">
                      <div className="col-2"><label><b>{couterpart.translate('order_date_from')}</b></label>:</div>
                      <div className="col-4">
                        <div className="customDatePickerWidth">
                          <DatePicker name="orderDateFrom" 
                            dateFormat="MM/dd/yyyy hh:mm"              
                            selected={ WorkOrderUtil.convertToDate(this.state.fromDate)}
                            onChange={this.handleFromDateChange.bind(this)}/></div>
                      </div>
                      <div className="col-2"><label><b>{couterpart.translate('order_date_to')}</b></label>:</div>
                      <div className="col-4">
                        <div className="customDatePickerWidth">
                          <DatePicker name="orderDateTo" 
                            dateFormat="MM/dd/yyyy hh:mm"
                            selected={ WorkOrderUtil.convertToDate(this.state.toDate)}
                            onChange={this.handleToDateChange.bind(this)}/>&nbsp;&nbsp;</div>
                      </div>                                        
                    </div>
                  </div>
                  <div className="col-8" style={{ padding: '5px'}}>
                    <div className="row">
                      <div className="col-2"><label><b>{couterpart.translate('work_order_country')}</b></label>:</div>
                      <div className="col-2">
                        { this.renderCountryList() }
                      </div>                   
                    </div>
                  </div>
                </div>              
                  <div className="row" style={{ margin: '2px'}}>
                    <div className="col-1"><label><b>{couterpart.translate('orders')}</b></label>:</div>
                    <div className="col-2">
                      { this.renderStatusList() }
                    </div>
                    <div className="col-2"><label><b>{couterpart.translate('work_orders')}</b></label>:</div>
                    <div className="col-2">
                      { this.renderWoStatusList() }
                    </div>                    
                    <div className="col-2">
                      <input type="text" defaultValue={this.state.customer} 
                        placeholder={couterpart.translate('customer_name')}
                        onChange={this.handleCustomerChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleCustomerChange(e) }, 0); }}/>
                    </div>
                    <div className="col-2">
                      <input type="text" defaultValue={this.state.orderNo} 
                        placeholder={couterpart.translate('order_no')}
                        onChange={this.handleOrderNoChange.bind(this)} onKeyDown = {(e) => { e.persist(); setTimeout(() => { this.handleOrderNoChange(e) }, 0); }}/>
                    </div>
                    <div className="col-1">
                      <button className="myButton" 
                        onClick={this.onFilter.bind(this)}>
                        <FaFilter color={ICON_COLOR}/>
                        &nbsp;{couterpart.translate('button_filter')}</button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row border-top border-left border-right border-bottom border-light-gray" style={{ margin: '2px'}}>
                <div className="col-2">
                  { this.renderChangeStatusList() }
                </div>
                <div className="col-3">
                  <input type="text" defaultValue="" style={{width:"100%", margin:"5px"}} placeholder={couterpart.translate('order_note')} onChange={this.handleOrderNoteChange.bind(this)}/>
                </div>
                <div className="col-3">
                  <button className="myButton" onClick={this.changeOrdersStatus.bind(this)}><FaEdit color={ICON_COLOR}/>&nbsp;{couterpart.translate('button_change')}</button>
                </div>
                <div  className="col-2"><OrderPrint ids={this.state.selected}/></div>        
              </div>
              <ReactTable
                // PaginationComponent={ReactTablePagination}
                className="-striped -highlight"
                previousText={"<"}
                nextText={">"}
                pageText={"Trang"}
                data={this.state.orders}
                columns={this.state.columns}
                defaultPageSize = {10}
                showPageSizeOptions = {true}
                pageSizeOptions = {[3, 5, 10, 20]}
                headerStyle= {{
                  'background-color' : 'green'
                }}
                page={this.state.selectedPage}
                onPageChange={(pageIndex) => {
                  if (this.state.selectedPage === pageIndex) {
                    this.setState({ selectedPage: pageIndex }, () => {
                      WorkOrderUtil.saveItem('orders.orderId', this.state.orderId);
                      WorkOrderUtil.saveItem('orders.selectedOrderNo', this.state.selectedOrderNo);
                      WorkOrderUtil.saveItem('orders.selectedPage', pageIndex);
                      WorkOrderUtil.saveItem('orders.selectedRow', this.state.selectedRow);
                    })
                  } else {
                    this.setState({ selectedPage: pageIndex, selectedRow: -1, selectedOrderNo: '',  orderId: 0}, () => {
                      WorkOrderUtil.saveItem('orders.orderId', this.state.orderId);
                      WorkOrderUtil.saveItem('orders.selectedOrderNo', this.state.selectedOrderNo);
                      WorkOrderUtil.saveItem('orders.selectedPage', pageIndex);
                      WorkOrderUtil.saveItem('orders.selectedRow', this.state.selectedRow);
                    })
                  }
                  this.setState({ selectedPage: pageIndex })             
                }}
                getTrProps={(state, rowInfo, column) => { 
                    if (rowInfo && rowInfo.row) {
                      // console.log('this.state.selectedRow - rowInfo.index',this.state.selectedRow, rowInfo.index)
                      return {
                        onClick: (e) => {
                          this.setState({
                            selectedRow: rowInfo.index,
                            orderId: rowInfo.original.id,
                            selectedOrderNo: rowInfo.original.orderNo,
                          }, ()=>{
                            WorkOrderUtil.saveItem('orders.orderId', this.state.orderId);
                            WorkOrderUtil.saveItem('orders.selectedOrderNo', this.state.selectedOrderNo);
                            WorkOrderUtil.saveItem('orders.selectedRow', this.state.selectedRow);
                          })
                        },
                        style: {
                          background: rowInfo.index === this.state.selectedRow ? '#DCDCDC' : 'white',
                          color: rowInfo.index === this.state.selectedRow ? 'white' : 'black',
                          padding:1
                        }
                      }
                    }else{
                      return {}
                    }
                  }
                }               
              />
              <WorkOrdersListByOrderId orderId={this.state.orderId} orderNo={this.state.selectedOrderNo} callbackFunc={this.onFilter.bind(this)}/>
          </div>      
    )
  }
}

export default withRouter(OrderList);